import React from "react";



interface IBoldTextButton {
    isDisabled?: boolean, 
    ariaLabel: string, 
    link?: string,
    onButtonClick?: any, 
    text: string,
    openInNewTab?: boolean
}

const BoldTextButton = ({isDisabled, ariaLabel, onButtonClick, link, text, openInNewTab = true}: IBoldTextButton) => {
   
   if (link) {
    return (
        <a
            className={`bold-text-button ${isDisabled ? 'disabled' : ''}`}
            aria-label={ariaLabel}
            href={isDisabled ? undefined : link}
            target={openInNewTab ? "_blank" : undefined}
            rel="noopener noreferrer"
            onClick={(e) => isDisabled && e.preventDefault()}
        >
            {text}
        </a> 
    )
    
   } 
    return (
        <button
            className={`bold-text-button`}
            disabled={isDisabled}
            aria-label={ariaLabel}
            onClick={onButtonClick}
            type='button'
        >
            {text}        
        </button>
    );
};

export default BoldTextButton